import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage,
  Font
} from '@react-pdf/renderer';
import { calculateAge } from '../../../../../utils/common';

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'bold' }]
});

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 0,
    marginBottom: 0,
    borderTop: '0.5px solid black',
    borderRight: '1px solid black',
    borderLeft: '1px solid black',
    borderBottom: '0.5px solid black',
    padding: 10
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 0,
    padding: 5,
    borderTop: '0.5px solid black',
    borderRight: '1px solid black',
    borderLeft: '1px solid black',
    borderBottom: '0.5px solid black'
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5
  },
  text: {
    fontSize: 9,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    marginTop: 5,
    minHeight: '100px'
  },
  tableRow: {
    flexDirection: 'row'
  },
  tableColHeader: {
    width: '14.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    backgroundColor: '#f0f0f0',
    padding: 5
  },
  tableCol: {
    width: '12.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    padding: 5
  },
  tableCellHeader: {
    fontSize: 10,
    fontWeight: 'bold'
  },
  tableCell: {
    fontSize: 10
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    padding: 5,
    border: '1px solid black',
    marginTop: 2,
    backgroundColor: '',
    color: 'white'
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    padding: 5,
    border: '1px solid black',
    marginTop: 2,
    backgroundColor: '',
    color: 'black'
  },
  headerText: {
    fontSize: 8,
    fontWeight: 'bold',
    marginLeft: 25,
    marginRight: 25
  },
  columnHeader: {
    width: 'auto'
  },
  columnText: {
    width: '10%',
    textAlign: 'center'
  },
  columnTextWide: {
    width: '17%',
    textAlign: 'center'
  },
  columnTextNarrow: {
    width: '5%',
    textAlign: 'center'
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const IVFTreatementPdf = ({ data }) => {
  console.log(data);
  const medicines = data?.medicines || [];
  const user = JSON.parse(localStorage.getItem('user'));
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title={`IVF Treatement`}>
          <Page size="A4" style={styles.page}>
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />
            <View style={styles.row}>
              <Text content="IVF Treatement" style={{ fontSize: '12px', margin: '0 auto', fontFamily: 'Roboto' }} />
            </View>
            <View style={styles.contentContainer}>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="Patient Name       :     " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
                  <Text
                    content={`${data.patient?.name_suffix} ${data.patient?.first_name} ${data.patient?.last_name}`}
                  />
                </View>
                <View style={styles.row}>
                  <Text content="UHID No.               :     " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
                  <Text content={`${data?.uhid || ''}`} />
                </View>
                <View style={styles.row}>
                  <Text
                    content="Address                 :                    "
                    style={{ ...styles.textBold, fontFamily: 'Roboto' }}
                  />
                  <Text content={`${data?.patient?.address?.address || ''}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Consultant            :     " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
                  <Text content={`${data.patient?.consultant?.name || ''}`} />
                </View>
              </View>
              <View style={styles.column}></View>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="Age/Sex               :      " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
                  <Text content={`${calculateAge(data.patient?.dob) || ''} / ${data.patient?.gender || ''}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Department         :     " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
                  <Text content={`${data?.patient?.department?.department || ''}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Mob No.               :     " style={{ ...styles.textBold, fontFamily: 'Roboto' }} />
                  <Text content={`${data?.patient?.address?.mobile || ''}`} />
                </View>
              </View>
            </View>


            <Text content="Patient History" style={{ ...styles.columnText, width: '20%', fontFamily: 'Roboto' }} />
            <View style={styles.headerContainer}>
              <Text content="S. No." style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="Marriage No." style={{ ...styles.columnText, width: '20%', fontFamily: 'Roboto' }} />
              <Text content="Married Year" style={{ ...styles.columnText, width: '20%', fontFamily: 'Roboto' }} />
              <Text content="Previous Delivery" style={{ ...styles.columnText, width: '20%', fontFamily: 'Roboto' }} />
              <Text content="Delivery Type" style={{ ...styles.columnText, width: '20%', fontFamily: 'Roboto' }} />
            </View>

            {data?.patient_history?.map((item, index) => (
              <View
                style={{
                  ...styles.row,
                  backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                  marginTop: 0,
                  padding: '5px'
                }}
                key={index}
              >
                <Text content={index + 1} style={{ ...styles.columnText, width: '10%' }} />
                <Text content={item.marriage_no || '-'} style={{ ...styles.columnText, width: '20%',textAlign:"right" }} />
                <Text content={item.married_year || '-'} style={{ ...styles.columnText, width: '20%',textAlign:"right" }} />
                <Text content={item.previous_delivery || '-'} style={{ ...styles.columnText, width: '20%',textAlign:"start" }} />
                <Text content={item.delivery_type || '-'} style={{ ...styles.columnText, width: '20%' ,textAlign:"start"}} />
              </View>
            ))}


                        {/* Table for Personal History */}
          <Text content="Personal History" style={{ ...styles.columnText, width: '20%', fontFamily: 'Roboto' }} />
            <View style={styles.headerContainer}>
              <Text content="S. No." style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="Breast Discharge" style={{ ...styles.columnText, width: '20%', fontFamily: 'Roboto' }} />
              <Text content="White Discharge" style={{ ...styles.columnText, width: '20%', fontFamily: 'Roboto' }} />
              <Text content="Dysmenorrhea" style={{ ...styles.columnText, width: '20%', fontFamily: 'Roboto' }} />
              <Text content="Breast Side" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="Details" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
            </View>

            {data?.personal_history?.map((item, index) => (
              <View
                style={{
                  ...styles.row,
                  backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                  marginTop: 0,
                  padding: '5px'
                }}
                key={index}
              >
                <Text content={index + 1} style={{ ...styles.columnText, width: '10%' }} />
                <Text content={item.breast_discharge || '-'} style={{ ...styles.columnText, width: '20%',textAlign:"start" }} />
                <Text content={item.white_discharge || '-'} style={{ ...styles.columnText, width: '20%',textAlign:"start" }} />
                <Text content={item.dysmenorrhea || '-'} style={{ ...styles.columnText, width: '20%',textAlign:"start" }} />
                <Text content={item.breast_side || '-'} style={{ ...styles.columnText, width: '15%',textAlign:"start" }} />
                <Text content={item.details || '-'} style={{ ...styles.columnText, width: '15%',textAlign:"start"}} />
              </View>
            ))}


            {/* Table */}
            <Text content="Family History" style={{ ...styles.columnText, width: '20%', fontFamily: 'Roboto' }} />
            <View style={styles.headerContainer}>
              <Text content="S. No." style={{ ...styles.columnText, width: '20%', fontFamily: 'Roboto' }} />
              <Text content="Disease" style={{ ...styles.columnText, width: '40%', fontFamily: 'Roboto' }} />
              <Text content="Relation" style={{ ...styles.columnText, width: '40%', fontFamily: 'Roboto' }} />
            </View>

            {data?.family_history?.map((item, index) => (
              <View
                style={{
                  ...styles.row,
                  backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                  marginTop: 0,
                  padding: '5px'
                }}
                key={index}
              >
                <Text content={index + 1} style={{ ...styles.columnText, width: '20%' }} />
                <Text content={item.disease || '-'} style={{ ...styles.columnText, width: '40%',textAlign:"start" }} />
                <Text content={item.description || '-'} style={{ ...styles.columnText, width: '40%',textAlign:"start" }} />
              </View>
            ))}

            <Text content="Infertility Details" style={{ ...styles.columnText, width: '20%', fontFamily: 'Roboto' }} />
            <View style={styles.headerContainer}>
              <Text content="S. No." style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto' }} />
              <Text
                content="Primary Infertility"
                style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }}
              />
              <Text
                content="Secondary Infertility"
                style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }}
              />
              <Text content="Abortion" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="DNC" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="Doctor" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="IUD" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
            </View>

            {data?.infertility_details?.map((item, index) => (
              <View
                style={{
                  ...styles.row,
                  backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                  marginTop: 0,
                  padding: '5px'
                }}
                key={index}
              >
                <Text content={index + 1} style={{ ...styles.columnText, width: '10%' }} />
                <Text content={item.primary_infertility || '-'} style={{ ...styles.columnText, width: '15%',textAlign:"right" }} />
                <Text content={item.secondary_infertility || '-'} style={{ ...styles.columnText, width: '15%' ,textAlign:"right"}} />
                <Text content={item.abortion || '-'} style={{ ...styles.columnText, width: '15%',textAlign:"right" }} />
                <Text content={item.dnc || '-'} style={{ ...styles.columnText, width: '15%',textAlign:"right" }} />
                <Text content={item.doctor || '-'} style={{ ...styles.columnText, width: '15%',textAlign:"start" }} />
                <Text content={item.iud || '-'} style={{ ...styles.columnText, width: '15%',textAlign:"start" }} />
              </View>
            ))}

            {/* Table for Complaint Items */}
            <Text content="Infertility Treatement" style={{ ...styles.columnText, width: '20%', fontFamily: 'Roboto' }} />
            <View style={styles.headerContainer}>
              <Text content="S. No." style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="Laproscopy" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="Hystroscopic" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="HSG" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="Medical Treatment" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="IUI" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="IVF/CSI" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
            </View>

            {data?.infertility_treatement?.map((item, index) => (
              <View
                style={{
                  ...styles.row,
                  backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                  marginTop: 0,
                  padding: '5px'
                }}
                key={index}
              >
                <Text content={index + 1} style={{ ...styles.columnText, width: '10%' }} />
                <Text content={item.laproscopy || '-'} style={{ ...styles.columnText, width: '15%',textAlign:"start" }} />
                <Text content={item.hystroscopic || '-'} style={{ ...styles.columnText, width: '15%',textAlign:"start" }} />
                <Text content={item.hsg || '-'} style={{ ...styles.columnText, width: '15%',textAlign:"start" }} />
                <Text content={item.medical_treatement || '-'} style={{ ...styles.columnText, width: '15%',textAlign:"start" }} />
                <Text content={item.iui || '-'} style={{ ...styles.columnText, width: '15%',textAlign:"start" }} />
                <Text content={item.ivf_csi || '-'} style={{ ...styles.columnText, width: '15%' ,textAlign:"start"}} />
              </View>
            ))}

            {/* Table for Medical History Items */}
            <Text content="Medical History" style={{ ...styles.columnText, width: '20%', fontFamily: 'Roboto' }} />
            <View style={styles.headerContainer}>
              <Text content="S. No." style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="TB" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="DM" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="HT" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="TB Fix" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="DM Years" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="DM Fix" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
            </View>

            {data?.medical_history?.map((item, index) => (
              <View
                style={{
                  ...styles.row,
                  backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                  marginTop: 0,
                  padding: '5px'
                }}
                key={index}
              >
                <Text content={index + 1} style={{ ...styles.columnText, width: '10%' }} />
                <Text content={item.tb || '-'} style={{ ...styles.columnText, width: '15%',textAlign:"start" }} />
                <Text content={item.dm || '-'} style={{ ...styles.columnText, width: '15%',textAlign:"start" }} />
                <Text content={item.ht || '-'} style={{ ...styles.columnText, width: '15%' ,textAlign:"start"}} />
                <Text content={item.tb_fix || '-'} style={{ ...styles.columnText, width: '15%',textAlign:"start" }} />
                <Text content={item.dm_years || '-'} style={{ ...styles.columnText, width: '15%',textAlign:"start" }} />
                <Text content={item.dm_fix || '-'} style={{ ...styles.columnText, width: '15%',textAlign:"start" }} />
              </View>
            ))}

        <Text content="Menustral History" style={{ ...styles.columnText, width: '20%', fontFamily: 'Roboto' }} />
            <View style={styles.headerContainer}>
              <Text content="S. No." style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="Previous Cycle" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="Present Cycle" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="Dysmenorrhea Type" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="Days" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="Details" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text
                content="Last Menstrual Date"
                style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }}
              />
            </View>

            {data?.menustral_history?.map((item, index) => (
              <View
                style={{
                  ...styles.row,
                  backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                  marginTop: 0,
                  padding: '5px'
                }}
                key={index}
              >
                <Text content={index + 1} style={{ ...styles.columnText, width: '10%' }} />
                <Text content={item.previous_cycle || '-'} style={{ ...styles.columnText, width: '15%' ,textAlign:"start"}} />
                <Text content={item.present_cycle || '-'} style={{ ...styles.columnText, width: '15%',textAlign:"start" }} />
                <Text content={item.dysmenorrhea_type || '-'} style={{ ...styles.columnText, width: '15%',textAlign:"start" }} />
                <Text content={item.days || '-'} style={{ ...styles.columnText, width: '15%',textAlign:"start" }} />
                <Text content={item.details || '-'} style={{ ...styles.columnText, width: '15%',textAlign:"start" }} />
                <Text
                  content={item.last_menustral_date ? new Date(item.last_menustral_date).toLocaleDateString() : '-'}
                  style={{ ...styles.columnText, width: '15%' }}
                />
              </View>
            ))}

            {/* Table for General Exam Items */}
            {/* Table for Obstetric Details */}
            <Text content="Obsteric Details" style={{ ...styles.columnText, width: '20%', fontFamily: 'Roboto' }} />
            <View style={styles.headerContainer}>
              <Text content="S. No." style={{ ...styles.columnText, width: '20%', fontFamily: 'Roboto' }} />
              <Text content="G" style={{ ...styles.columnText, width: '26.5%', fontFamily: 'Roboto' }} />
              <Text content="P" style={{ ...styles.columnText, width: '26.5%', fontFamily: 'Roboto' }} />
              <Text content="L" style={{ ...styles.columnText, width: '26.5%', fontFamily: 'Roboto' }} />
              <Text content="MTP" style={{ ...styles.columnText, width: '26.5%', fontFamily: 'Roboto' }} />
            </View>

            {data?.obsteric_details?.map((item, index) => (
              <View
                style={{
                  ...styles.row,
                  backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                  marginTop: 0,
                  padding: '5px'
                }}
                key={index}
              >
                <Text content={index + 1} style={{ ...styles.columnText, width: '20%' }} />
                <Text content={item.g || '-'} style={{ ...styles.columnText, width: '26.5%',textAlign:"start" }} />
                <Text content={item.p || '-'} style={{ ...styles.columnText, width: '26.5%',textAlign:"start" }} />
                <Text content={item.l || '-'} style={{ ...styles.columnText, width: '26.5%',textAlign:"start" }} />
                <Text content={item.mtp || '-'} style={{ ...styles.columnText, width: '26.5%',textAlign:"start" }} />
              </View>
            ))}

            {/* Table for Investigation Items */}
            <Text content="Ovulation Study" style={{ ...styles.columnText, width: '20%', fontFamily: 'Roboto' }} />
            <View style={styles.headerContainer}>
              <Text content="S. No." style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="Date" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="LMP Date" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="Indication" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="Injection" style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="Tablet" style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="Follow Up Date" style={{ ...styles.columnText, width: '15%', fontFamily: 'Roboto' }} />
              <Text content="Called For" style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto' }} />
            </View>

            {data?.ovulation_study?.map((item, index) => (
              <View
                style={{
                  ...styles.row,
                  backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                  marginTop: 0,
                  padding: '5px'
                }}
                key={index}
              >
                <Text content={index + 1} style={{ ...styles.columnText, width: '10%' }} />
                <Text
                  content={new Date(item.date).toLocaleDateString() || '-'}
                  style={{ ...styles.columnText, width: '15%' }}
                />
                <Text
                  content={new Date(item.lmp_date).toLocaleDateString() || '-'}
                  style={{ ...styles.columnText, width: '15%' }}
                />
                <Text content={item.indication || '-'} style={{ ...styles.columnText, width: '15%' ,textAlign:"start"}} />
                <Text content={item.injection || '-'} style={{ ...styles.columnText, width: '10%',textAlign:"start" }} />
                <Text content={item.tablet || '-'} style={{ ...styles.columnText, width: '10%',textAlign:"start" }} />
                <Text
                  content={new Date(item.follow_up_date).toLocaleDateString() || '-'}
                  style={{ ...styles.columnText, width: '15%'}}
                />
                <Text content={item.called_for || '-'} style={{ ...styles.columnText, width: '10%',textAlign:"start" }} />
              </View>
            ))}
            {/* Table for Prescription Items */}
            {/* Table for Patient History */}
        

            {/* Table for Surgical History */}
            <Text content="Surgical History" style={{ ...styles.columnText, width: '20%', fontFamily: 'Roboto' }} />
            <View style={styles.headerContainer}>
              <Text content="S. No." style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="Surgery" style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="Laparoscopy" style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="Uterus" style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="Fibroid" style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="Right Ovary" style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="Right Tube" style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="Endometriosis" style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto' }} />
              <Text content="Adhesion" style={{ ...styles.columnText, width: '10%', fontFamily: 'Roboto' }} />
            </View>

            {data?.surgical_history?.map((item, index) => (
              <View
                style={{
                  ...styles.row,
                  backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                  marginTop: 0,
                  padding: '5px'
                }}
                key={index}
              >
                <Text content={index + 1} style={{ ...styles.columnText, width: '10%' }} />
                <Text content={item.surgery || '-'} style={{ ...styles.columnText, width: '10%',textAlign:"start" }} />
                <Text content={item.laparoscopy || '-'} style={{ ...styles.columnText, width: '10%',textAlign:"start"}} />
                <Text content={item.uterus || '-'} style={{ ...styles.columnText, width: '10%',textAlign:"start" }} />
                <Text content={item.fibroid || '-'} style={{ ...styles.columnText, width: '10%',textAlign:"start" }} />
                <Text content={item.rt_ovary || '-'} style={{ ...styles.columnText, width: '10%',textAlign:"start" }} />
                <Text content={item.rt_tube || '-'} style={{ ...styles.columnText, width: '10%',textAlign:"start" }} />
                <Text content={item.endometriosis || '-'} style={{ ...styles.columnText, width: '10%',textAlign:"start" }} />
                <Text content={item.adhension || '-'} style={{ ...styles.columnText, width: '10%',textAlign:"start" }} />
              </View>
            ))}
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};
